import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Printer, ShoppingCart, ArrowLeft } from 'lucide-react';
import { CURRENT_GIFT_CHAPTER } from '../data/gift-chapter';
import ShareButtons from './ShareButtons';

export default function GiftReadPage() {
  const navigate = useNavigate();
  const meta = CURRENT_GIFT_CHAPTER;

  // Gate: must have signed up
  useEffect(() => {
    const unlocked = localStorage.getItem('tav_gift_unlocked');
    if (!unlocked) navigate('/gift', { replace: true });
  }, [navigate]);

  const renderBlock = (b, i) => {
    switch (b.type) {
      case 'emphasis':
        return <p key={i} className="gr-emphasis">{b.text}</p>;
      case 'revelation':
        return <blockquote key={i} className="gr-revelation">{b.text}</blockquote>;
      case 'subheading':
        return <h2 key={i} className="gr-subheading">{b.text}</h2>;
      case 'list':
        return (
          <ul key={i} className="gr-list">
            {b.items.map((item, j) => <li key={j}>{item}</li>)}
          </ul>
        );
      default:
        return (
          <p key={i} className="gr-paragraph">
            {b.text.split('\n').map((line, k) => (
              <span key={k}>{line}<br /></span>
            ))}
          </p>
        );
    }
  };

  return (
    <section data-testid="gift-read-page" className="gr">
      <div className="gr-actions" data-testid="gr-actions">
        <Link to="/" className="gr-back-btn" data-testid="gr-back">
          <ArrowLeft size={14} /> The Village
        </Link>
        <button
          type="button"
          className="gr-action-btn"
          data-testid="gr-print"
          onClick={() => window.print()}
        >
          <Printer size={14} /> Save as PDF
        </button>
        <a
          href={meta.amazonUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="gr-action-btn gr-action-btn--amazon"
          data-testid="gr-amazon"
        >
          <ShoppingCart size={14} /> Get on Amazon
        </a>
      </div>

      <article className="gr-article" data-testid="gr-article">
        <header className="gr-header">
          <p className="gr-eyebrow">F.U.C.K. T.H.A.T.T. — What Do I Want NOW!</p>
          <p className="gr-chapter-num">Chapter {meta.chapterNumber}</p>
          <h1 className="gr-title" data-testid="gr-title">{meta.title}</h1>
          <p className="gr-author">by Cabrini Schnyder</p>
          <div className="gr-divider" />
        </header>

        <div className="gr-body" data-testid="gr-body">
          {meta.content.map(renderBlock)}
        </div>

        <footer className="gr-footer">
          <div className="gr-end-mark">~</div>
          <p className="gr-end-line">End of Chapter {meta.chapterNumber}</p>

          <div className="gr-cta-card">
            <img className="gr-cta-cover" src={meta.bookCover} alt="" />
            <div className="gr-cta-text">
              <p className="gr-cta-eyebrow">Loved this chapter?</p>
              <h3 className="gr-cta-title">Read the rest of the book.</h3>
              <p className="gr-cta-sub">
                The full F.U.C.K. T.H.A.T.T. journey — all 10 chapters, the 5 Principles, and the 7-Day Reset — available on Amazon.
              </p>
              <a
                href={meta.amazonUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="gr-cta-btn"
                data-testid="gr-cta-amazon"
              >
                <ShoppingCart size={16} /> Get the Full Book on Amazon
              </a>
            </div>
          </div>

          <p className="gr-next-month">
            <strong>New chapter drops every month.</strong> You're on the list — we'll let you know when the next one is ready.
          </p>

          <ShareButtons
            url="https://thealchemyvillage.com/gift"
            title={`Free chapter from "F.U.C.K. T.H.A.T.T." by Cabrini Schnyder`}
            text={`"${meta.title}" — a free monthly gift from The Alchemy Village.`}
            image={meta.bookCover}
            variant="gold"
          />
        </footer>
      </article>
    </section>
  );
}
